import { useRef as t } from "react";
const i = () => {
  const r = t(void 0), e = t(Date.now());
  return {
    check: () => {
      const n = Date.now(), c = r.current ? n - e.current : void 0;
      return r.current = e.current, e.current = n, c;
    }
  };
};
export {
  i as useTimer
};
